// Module
var code = "<div id=\"mainTOTPView\">\n\t<div id=\"totpLabel\" class=\"helpText\" data-i18n=\"[prepend]web::totp.mainview.message\"></div>\n</div>";
// Exports
module.exports = code;